import { UIGameSpriteHandler } from '../../UIGameSpriteHandler.ts';
import { UIGameBaseTileController } from './UIGameTileControllerBase.ts';
import { GameStateEnums } from '../../../../../shared/GameEnums.ts';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
import { TileHex } from '@colonist/game-mechanic-validators';
export class UIGameFogTileController extends UIGameBaseTileController {
    onEvent(data, eventType) {
        switch(eventType){
            case UIGameEventEnums.MapStateUpdated:
                this.updateFogTiles();
                break;
            default:
                break;
        }
    }
    getFogTiles() {
        const fogTiles = [];
        for(const fogTileGroupKey in this.fogTileGroupStates){
            const fogTileGroup = this.fogTileGroupStates[fogTileGroupKey];
            if (fogTileGroup == undefined) continue;
            for (const fogTileIndex of fogTileGroup.fogTileIndexes){
                const tile = this.uiGameManager.gameController.mapValidator.tileState.tiles[fogTileIndex];
                const tileClone = new TileHex({
                    x: tile.hexFace.x,
                    y: tile.hexFace.y,
                    type: tile.tileType,
                    diceNumber: tile.diceNumber
                });
                fogTiles.push(tileClone);
            }
        }
        return fogTiles;
    }
    updateFogTiles() {
        for (const tile of this.fogTiles){
            const currentTile = this.uiGameManager.gameController.mapValidator.tileState.getTileHex(tile.hexFace);
            if (currentTile == undefined) continue;
            if (currentTile.tileType == tile.tileType) continue;
            tile.state.type = currentTile.tileType;
            this.updateTileTexture(tile);
            this.uiGameManager.mapController.mapView.sortChildren();
        }
    }
    updateTileTexture(tile) {
        const texture = UIGameSpriteHandler.getHexImage(tile.tileType);
        const foregroundTexture = UIGameSpriteHandler.getHexForegroundImage(tile.tileType);
        for (const tileView of this.uiGameManager.mapController.tileViews){
            if (!tile.hexFace.sameFace(tileView.hexFace)) continue;
            tileView.updateTextures(texture, foregroundTexture);
        }
    }
    constructor(uiGameManager, fogTileGroupStates){
        super(uiGameManager);
        this.fogTileGroupStates = fogTileGroupStates;
        this.fogTiles = this.getFogTiles();
        this.uiGameManager.eventController.registerUIGameMechanic(this);
    }
}
